import React from 'react';
import { withPrefix, Link } from 'gatsby';
import { Slide } from 'react-slideshow-image';


const properties = {
  duration: 5000,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  arrows: true,
};

const SliderBlock = () => {
  return (
    <section className="sliderblock">
      <div className="slide-container">
        <Slide {...properties}>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${withPrefix('/img/Messe1.jpg')})`}}>
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${withPrefix('/img/Messe2.jpg')})`}}>
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${withPrefix('/img/Messe3.jpg')})`}}>
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${withPrefix('/img/Messe4.jpg')})`}}>
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${withPrefix('/img/Messe5.jpg')})`}}>
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${withPrefix('/img/Messe6.jpg')})`}}>
            </div>
          </div>
        </Slide>
      </div>
    </section>
  );
};

export default SliderBlock;
